<template>
  <div>register</div>
</template>

<script>
export default {};
</script>

<style></style>
